// Presentación de los estatus de nómina, compartida por la bandeja y la pantalla de
// prenómina. Antes el mapa de colores vivía DENTRO del render() de PreNomina.js, así
// que la bandeja no tenía de dónde tomarlo y habría acabado con su propia copia.
//
// La clasificación de fondo (qué estatus sigue siendo trabajo pendiente y qué ya
// consumió el periodo) la decide el backend y llega en el campo `clase` de la
// respuesta — ver Components/prenominaEstatusBloqueada.js. Aquí sólo se pinta.

export const ESTATUS_COLOR = {
  borrador: 'default',
  calculada: 'green',
  modificada: 'blue',
  cerrada: 'orange',
  parcialmente_timbrada: 'gold',
  timbrada: 'purple',
  pagada: 'purple',
  historica: 'cyan',
  cancelada: 'red',
}

export const ESTATUS_LABEL = {
  borrador: 'Borrador',
  calculada: 'Calculada',
  modificada: 'Modificada',
  cerrada: 'Cerrada',
  parcialmente_timbrada: 'Parcial',
  timbrada: 'Timbrada',
  pagada: 'Pagada',
  historica: 'Histórica',
  cancelada: 'Cancelada',
}

export const colorEstatus = (estatus) => ESTATUS_COLOR[estatus] || 'default'
export const nombreEstatus = (estatus) => ESTATUS_LABEL[estatus] || estatus || ''

// Etiqueta de un periodo en el selector: o está libre, o muestra el estatus de su
// prenómina. Un periodo sin prenómina activa llega con `prenomina: null`.
export const etiquetaEstadoPeriodo = (p) =>
  !p?.prenomina?.estatus
    ? { texto: 'Libre', color: 'default' }
    : { texto: nombreEstatus(p.prenomina.estatus), color: colorEstatus(p.prenomina.estatus) }
